import pageMeta from 'btm-pageMeta/pageMeta'; //eslint-disable-line import/no-unresolved, import/extensions

const $footer = $('.footer');
const $footerLanguageShelf = $footer.find($('.footer-language-shelf'));
const $languageSelectionLink = $footerLanguageShelf.find('.language-selection-item');
const selectedLanguageClass = 'language-selection-item-selected';

const browserLanguageWhitelist = [
    'es-AR', 'es-BO', 'es-CL', 'es-CO',
    'es-CR', 'es-CU', 'es-DO', 'es-EC',
    'es-GT', 'es-HN', 'es-HT', 'es-MX',
    'es-NI', 'es-PA', 'es-PE', 'es-PR',
    'es-PY', 'es-SV', 'es-US', 'es-UY',
    'es-VE', 'es-ES', 'es-419', 'es-XL',
    'es'
];

const browserLanguage = navigator.languages ?
    navigator.languages[0] : (navigator.language || navigator.userLanguage);

//We are splitting this so we always get 'en' and not 'en-CA, en-US' etc.
const locale = pageMeta.locale.split('_')[0];

function getBasePath() {
    if (location.pathname.indexOf('/en') === 0) {
        return location.pathname.slice(3) + location.search || '/';
    }

    if (locale === 'en') {
        return location.pathname + location.search || '/';
    }

    return location.pathname.slice(3) + location.search || '/';
}

function buildUrl(lang) {
    const baseUrl = getBasePath();

    if (lang === 'en') {
        return baseUrl;
    } else {
        return `/${lang}${baseUrl}`;
    }
}

function languageRedirect(lang) {
    const newUrl = buildUrl(lang);
    window.location = newUrl;
}

function setupLink($link) {
    const lang = $link.data('lang');
    if (lang !== locale) {
        languageRedirect(lang);
    }
}

function checkBrowserLanguage() {
    const lang = browserLanguage.split('-')[0];

    if (browserLanguageWhitelist.indexOf(browserLanguage) >= 0 && (lang !== locale)) {
        languageRedirect(lang);
    }
}

function setSelectedLanguageClass() {

    $languageSelectionLink.each((idx, item) => {
        const $item = $(item);
        if ($item.data('lang') === locale) {
            $item.addClass(selectedLanguageClass);
        } else {
            $item.removeClass(selectedLanguageClass);
        }
    });
}


export default {
    setSelectedLanguageClass,
    setupLink,
    checkBrowserLanguage
};
